<template>
  <div class="adviser-appointment-type-selection vff-animate q-form f-fade-in-up">
    <div class="q-inner">
      <div>
        <div class="fh2">
          <div class="f-answer f-full-width">
            <div class="f-radios-wrap">
              <CustomRadioList
                :options="radioListOptions"
                layout="vertical"
                label-align="start"
                @option-selected="handleAppointmentSelected"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { router } from '@inertiajs/vue3'
import { SelectAdviserAppointmentPathData } from '~types/concierge'
import CustomRadioList, {
  RadioListOption
} from '~conciergeUiCommons/components/CustomRadioList.vue'

export default defineComponent({
  name: 'AdviserAppointmentTypeSelection',
  components: { CustomRadioList },
  props: {
    paths: {
      type: Object as PropType<Record<string, SelectAdviserAppointmentPathData>>,
      required: true
    }
  },
  computed: {
    radioListOptions(): RadioListOption[] {
      const pathsArray = Object.values(this.paths)

      return pathsArray.map(path => ({
        label: this.$t('adviser_appointment_type.paths.' + path.question),
        icon: path.icon,
        value: path
      }))
    }
  },
  methods: {
    goToAppointmentForm(path: SelectAdviserAppointmentPathData) {
      if (Object.hasOwn(path, 'url')) {
        return router.visit(path.url)
      }
    },
    handleAppointmentSelected(value: any, option: RadioListOption) {
      const pathsArray = Array.isArray(this.paths) ? this.paths : Object.values(this.paths)

      const path = pathsArray.find(
        p => this.$t('adviser_appointment_type.paths.' + p.question) === option.label
      )
      if (path) {
        this.goToAppointmentForm(path)
      }
    }
  }
})
</script>
